import React from 'react'

const InventoryAdjustments = () => {
  return (
    <div>InventoryAdjustments</div>
  )
}

export default InventoryAdjustments